import React from "react";
import styled from "styled-components";
import videoSrc from "../../assets/video/video_0629.mp4";
import poster from "../../assets/images/main_banner.jpg";
import {device} from "../../assets/styles/media.js";

const VisualVideo = styled.div`
    width: 100%;
    margin: 0 auto;
    height: calc(100vh - 15vh);
    
    ${device.mobile}{
        height: calc(100vh - 20vh);
    }
`;
const Video = styled.video`
    width: 100%;
    height: calc(100vh - 15vh);
    object-fit: cover;
`;
const MainVideo = () => {
    return (
        <VisualVideo>
            <Video
                src={videoSrc}
                poster={poster}
                autoPlay
                loop
                preload="auto"
                playsInline
                muted
            />
        </VisualVideo>
    );
};

export default MainVideo;
